var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-list-wrap"},[_c('h1',{staticClass:"dq-list-title"},[_vm._v("西餐系列")]),_c('classList',{attrs:{"getData":_vm.postData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }